import { render, staticRenderFns } from "./ModalTambahBahanPacking.vue?vue&type=template&id=25519f64&scoped=true&"
import script from "./ModalTambahBahanPacking.vue?vue&type=script&lang=js&"
export * from "./ModalTambahBahanPacking.vue?vue&type=script&lang=js&"
import style0 from "./ModalTambahBahanPacking.vue?vue&type=style&index=0&id=25519f64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25519f64",
  null
  
)

export default component.exports